import type { ViewFieldsFragment } from '@salescore/client-api'
import { POSTHOG_EVENTS, posthogTrackClick } from '@salescore/client-base'
import type { CompiledKpiPivotViewConfig, CompiledKpiViewConfig } from '@salescore/core'
import { CsvDownloadWithTextButton, generateCsvString } from '@salescore/frontend-common'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { usePivotColumns } from '../../../hooks/usePivotColumns'
import { useRecordsImpl } from '../../../recoil/records'
import { generateDashboardCsvColumns } from './generateDashboardCsvColumns'
import { generateDashboardCsvData } from './generateDashboardCsvData'

export const DashboardCsvDownloadButton = ({
  compiledConfig,
  view,
  shouldIncludeGoal,
}: {
  compiledConfig: CompiledKpiViewConfig | CompiledKpiPivotViewConfig
  view: ViewFieldsFragment
  shouldIncludeGoal: boolean
}): ReactElement => {
  const rows = useRecordsImpl()
  const { rowColumns, pivotColumns } = usePivotColumns(compiledConfig, view)

  return (
    <CsvDownloadWithTextButton
      type="default"
      text={t('CSVダウンロード')}
      filename={view.name}
      onClick={() => {
        posthogTrackClick(POSTHOG_EVENTS.click_dashboard_csv_download, view.id)
      }}
      fetch={
        // eslint-disable-next-line @typescript-eslint/require-await
        async () => {
          const columns = generateDashboardCsvColumns(
            rows,
            rowColumns.map((column) => ({
              title: column.title,
              fieldName: column.field.name,
              nodePath: column.node.path,
            })),
            pivotColumns.map((column) => ({
              title: column.title,
              fieldName: column.field.name,
              nodePath: column.node.path,
              blockLabels: column.nodeBlock.labels,
            })),
          )
          const csvData = generateDashboardCsvData(columns, shouldIncludeGoal, {
            actual: t('実績'),
            goal: t('目標'),
          })

          return generateCsvString(csvData)
        }
      }
    />
  )
}
